import { ReferralForm } from '@/components/ReferralForm';
import { Sparkles } from 'lucide-react';

export function ReferralPage() {
  return (
    <div className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-africa-green/8 blur-3xl" />
        <div className="absolute top-1/3 -left-48 w-80 h-80 rounded-full bg-africa-blue/8 blur-3xl" />
        <div className="absolute bottom-20 right-10 w-64 h-64 rounded-full bg-africa-orange/6 blur-3xl" />
        <div className="absolute top-2/3 left-1/3 w-48 h-48 rounded-full bg-africa-purple/6 blur-3xl" />
        <div className="absolute bottom-1/4 -right-20 w-56 h-56 rounded-full bg-africa-red/5 blur-3xl" />
      </div>

      <div className="relative px-4 py-12 md:py-20">
        <div className="flex justify-center mb-10">
          <div className="flex h-1 w-48 rounded-full overflow-hidden">
            <div className="flex-1 bg-africa-red" />
            <div className="flex-1 bg-africa-orange" />
            <div className="flex-1 bg-africa-yellow" />
            <div className="flex-1 bg-africa-green" />
            <div className="flex-1 bg-africa-blue" />
            <div className="flex-1 bg-africa-purple" />
          </div>
        </div>

        <div className="max-w-3xl mx-auto text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent/10 text-accent text-sm font-medium mb-6">
            <Sparkles className="w-4 h-4" />
            Referral Program
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-foreground leading-tight mb-4">
            <span>Invite Innovators</span>
            {' '}to{' '}
            <span className="text-accent">Homeland Ecosystem</span>
            {' '}
            <span>Hub</span>
          </h1>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            Know someone building the future? Refer up to 10 people to join our
            innovation community across technology, business, and beyond.
          </p>

          <div className="flex flex-wrap justify-center gap-2 mt-6">
            <span className="px-3 py-1 rounded-full text-xs font-medium bg-africa-green/10 text-africa-green border border-africa-green/20">
              AI tools & automation
            </span>
            <span className="px-3 py-1 rounded-full text-xs font-medium bg-africa-blue/10 text-africa-blue border border-africa-blue/20">
              Building with AI
            </span>
            <span className="px-3 py-1 rounded-full text-xs font-medium bg-africa-orange/10 text-africa-orange border border-africa-orange/20">
              Innovation & startups
            </span>
            <span className="px-3 py-1 rounded-full text-xs font-medium bg-africa-red/10 text-africa-red border border-africa-red/20">
              AI research
            </span>
            <span className="px-3 py-1 rounded-full text-xs font-medium bg-africa-purple/10 text-africa-purple border border-africa-purple/20">
              Learning & growth
            </span>
          </div>
        </div>

        <ReferralForm />

        <p className="text-center text-xs text-muted-foreground mt-12 max-w-md mx-auto">
          By submitting, you confirm that you have permission to share these
          contacts. Invitees will receive an email or SMS invitation.
        </p>
      </div>
    </div>
  );
}
